import React from "react";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import ProductCard from "../components/site/ProductCard";
import useReveal from "../hooks/useReveal";
import { STATIC_PRODUCTS } from "../lib/staticProducts";

export default function Books() {
    useReveal();
    const items = STATIC_PRODUCTS.filter((p) => p.category === "buch");

    return (
        <main
            data-testid="books-page"
            className="min-h-screen bg-cream-50 text-ink-900 font-sans"
        >
            <Navbar />
            <section className="pt-36 pb-16 md:pt-44 bg-cream-100 border-b border-cream-300">
                <div className="max-w-6xl mx-auto px-6 md:px-10 text-center reveal">
                    <span className="divider-dot mb-6"><span>Buchhandlung</span></span>
                    <h1 data-testid="books-page-heading" className="font-serif font-light text-5xl md:text-6xl tracking-tight text-ink-900 leading-[1.05]">
                        Unsere <em className="italic text-mauve-500">Buchhandlung</em>
                    </h1>
                    <p className="mt-6 text-base md:text-lg text-ink-700 leading-relaxed font-light max-w-2xl mx-auto">
                        Eine kleine, sorgfältig kuratierte Auswahl an Büchern — für den Weg des Wissens: Lesen, Nachdenken und Wiederholen.
                    </p>
                </div>
            </section>
            <section className="py-20 max-w-6xl mx-auto px-6 md:px-10">
                <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-10 md:gap-8">
                    {items.map((p) => <ProductCard key={p.id} product={p} testId={`book-card-${p.id}`} />)}
                </div>
            </section>
            <Footer />
        </main>
    );
}
